function h(s, t, e, r, i, n, c, p) {
  var d = typeof s == "function" ? s.options : s;
  return t && (d.render = t, d.staticRenderFns = e, d._compiled = !0), {
    exports: s,
    options: d
  };
}
const f = {};
var v = function() {
  var t = this, e = t._self._c;
  return e("svg", { attrs: { viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" } }, [e("path", { attrs: { d: "M5.25977 1.46979L1.73977 4.99979L5.25977 8.52979", stroke: "currentColor", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" } })]);
}, u = [], C = /* @__PURE__ */ h(
  f,
  v,
  u
);
const g = C.exports, w = {
  components: { Left: g },
  props: {
    header: {
      type: Object,
      required: !0
    },
    support: {
      type: Object,
      default: null
    },
    items: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      isMobile: window.innerWidth < 1024,
      collapsed: window.innerWidth < 1024,
      childrenCollapsed: [],
      showToolbar: !1,
      toolTip: { top: "", left: "" },
      toolBarItem: null,
      windowHeight: window.innerHeight
    };
  },
  watch: {
    "$route.path": function() {
      this.isMobile && (this.collapsed = !0);
    },
    "this.items": {
      immediate: !0,
      handler() {
        this.checkActiveChildren(), this.initializeCollapsedFromLocalStorage();
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.updateCollapsedState);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateCollapsedState);
  },
  methods: {
    checkActiveChildren() {
      var s, t;
      for (const e of this.items) {
        let r = !1;
        if (e.children) {
          for (const i of e.children) {
            let n = (s = i == null ? void 0 : i.to) != null && s.name ? (t = i == null ? void 0 : i.to) == null ? void 0 : t.name : i == null ? void 0 : i.to;
            if (n = n.replace(/[^\w\s]/g, ""), this.$route.path.replace(/[^\w\s]/g, "") === n) {
              r = !0;
              break;
            }
          }
          this.childrenCollapsed.push(r);
        }
      }
    },
    mouseEnterHandler(s, t) {
      var n, c;
      if (!this.collapsed)
        return;
      this.showToolbar = !0, this.toolBarItem = t;
      const e = s.currentTarget.getBoundingClientRect();
      this.toolTip.top = e.top - 56 + "px", this.toolTip.left = e.left + 50 + "px";
      const r = this.windowHeight - e.top, i = (c = (n = this.toolBarItem) == null ? void 0 : n.children) == null ? void 0 : c.length;
      if (i) {
        const p = 40 * i;
        r < p && (this.toolTip.top = e.top - 15 - p + "px");
      }
    },
    toggleSidebar() {
      this.collapsed ? setTimeout(() => {
        this.collapsed = !1, localStorage.removeItem("collapsed");
      }, 200) : (this.collapsed = !0, localStorage.setItem("collapsed", "true"));
    },
    initializeCollapsedFromLocalStorage() {
      if (this.isMobile)
        return;
      localStorage.getItem("collapsed") ? this.collapsed = !0 : this.collapsed = !1;
    },
    updateCollapsedState() {
      this.collapsed = window.innerWidth < 1024;
    },
    beforeEnter(s) {
      s.style.height = "0px", s.style.overflow = "hidden";
    },
    enter(s, t) {
      const e = s.scrollHeight;
      s.style.transition = "height 0.5s ease", s.style.height = e + "px", s.addEventListener("transitionend", () => {
        s.style.height = "auto", t();
      });
    },
    leave(s, t) {
      const e = s.scrollHeight;
      s.style.height = e + "px", s.style.transition = "height 0.5s ease", setTimeout(() => {
        s.style.height = "0px";
      }, 100), s.addEventListener("transitionend", t);
    }
  }
};
var k = function() {
  var r, i, n, c, p, d;
  var t = this, e = t._self._c;
  return e("div", [t.collapsed ? t._e() : e("div", { staticClass: "overlay", on: { click: function(o) {
    t.collapsed = !0;
  } } }), e("div", { staticClass: "sidebar-side", class: [{ "sidebar-side-collapsed": t.collapsed }], style: { padding: t.support ? "15px 15px 100px" : "15px 15px 55px" } }, [e("div", { staticClass: "header" }, [e("router-link", { staticClass: "header-link", attrs: { "active-class": "router-link-active", to: (r = t.header) != null && r.to ? (i = t.header) == null ? void 0 : i.to : "" } }, [t.collapsed ? t._e() : e("div", { staticClass: "header-el" }, [e((n = t.header) == null ? void 0 : n.logo, { tag: "component", attrs: { width: "24" } }), e("p", { staticClass: "header-title" }, [t._v(" " + t._s(t.header.name) + " ")])], 1)]), e("button", { staticClass: "collapse-btn", class: [{ "collapse-btn-collapsed": t.collapsed }], on: { click: t.toggleSidebar } }, [e("Left", { attrs: { width: "10" } })], 1), t.collapsed ? e("button", { staticClass: "mobile-collapsed-btn", on: { click: t.toggleSidebar } }, [e("Left", { attrs: { width: "10" } })], 1) : t._e()], 1), e("div", [t.collapsed ? t._e() : t._t("subHeader")], 2), e("div", { staticClass: "navigation", on: { mouseleave: function(o) {
    t.showToolbar = !1;
  } } }, [t._l(t.items, function(o, l) {
    return e("div", { key: `item-${l}` }, [o.to && !o.children ? e("router-link", { staticClass: "link", attrs: { to: o == null ? void 0 : o.to, "active-class": "router-link-active" } }, [e("div", { staticClass: "div-el", on: { mouseenter: function(a) {
      return t.mouseEnterHandler(a, o);
    } } }, [typeof (o == null ? void 0 : o.icon) == "string" ? e("span", { staticClass: "icon", domProps: { innerHTML: t._s(o == null ? void 0 : o.icon) } }) : e(o.icon, { tag: "component", staticClass: "icon" }), t.collapsed ? t._e() : e("span", [t._v(t._s(o.title) + " ")]), t.collapsed && o.notification ? e("span", { staticClass: "notification notification-collapsed" }, [t._v(t._s(o.notification))]) : t._e(), !t.collapsed && o.notification ? e("span", { staticClass: "notification notification-no-collapsed" }, [t._v(t._s(o.notification))]) : t._e()], 1)]) : e("div", { staticClass: "link" }, [e("div", { staticClass: "div-el", on: { click: function(a) {
      t.collapsed || t.$set(t.childrenCollapsed, l, !t.childrenCollapsed[l]);
    }, mouseenter: function(a) {
      return t.mouseEnterHandler(a, o);
    } } }, [typeof (o == null ? void 0 : o.icon) == "string" ? e("span", { staticClass: "icon", domProps: { innerHTML: t._s(o == null ? void 0 : o.icon) } }) : e(o.icon, { tag: "component", staticClass: "icon" }), t.collapsed ? t._e() : e("div", [e("span", [t._v(t._s(o.title))]), o.children ? e("Left", { staticClass: "down-icon", class: t.childrenCollapsed[l] ? "up" : "", attrs: { width: "8" } }) : t._e()], 1)], 1)]), e("transition", { on: { "before-enter": t.beforeEnter, enter: t.enter, leave: t.leave } }, [t.childrenCollapsed[l] && !t.collapsed ? e("div", { staticClass: "children" }, t._l(o.children, function(a, _) {
      return e("div", { key: `subItem-${_}` }, [e("router-link", { attrs: { "active-class": "router-link-active", to: a.to ? a.to : "" } }, [e("div", { staticClass: "children-div" }, [typeof (a == null ? void 0 : a.icon) == "string" ? e("span", { staticClass: "icon", domProps: { innerHTML: t._s(a == null ? void 0 : a.icon) } }) : e(a.icon, { tag: "component", staticClass: "icon" }), t.collapsed ? t._e() : e("span", [t._v(t._s(a.title))]), a.notification ? e("span", { staticClass: "notification notification-no-collapsed" }, [t._v(t._s(a.notification))]) : t._e()], 1)])], 1);
    }), 0) : t._e()])], 1);
  }), e("div", { staticClass: "support" }, [t._t("footer", function() {
    var o, l, a;
    return [t.support ? [e("a", { staticClass: "t", attrs: { href: (o = t.support) == null ? void 0 : o.to, target: "_blank" } }, [(l = t.support) != null && l.icon ? e(t.support.icon, { tag: "component" }) : t._e(), t.collapsed ? t._e() : e("span", [t._v(t._s((a = t.support) == null ? void 0 : a.title))])], 1)] : t._e()];
  })], 2), e("div", { directives: [{ name: "show", rawName: "v-show", value: t.showToolbar, expression: "showToolbar" }], staticClass: "toolbar", style: t.toolTip, attrs: { id: "toolbar" } }, [(c = t.toolBarItem) != null && c.children ? t._l(t.toolBarItem.children, function(o, l) {
    return e("div", { key: `toolBarItem-${l}`, staticClass: "child" }, [e("router-link", { attrs: { "active-class": "router-link-active", to: o != null && o.to ? o.to : "" } }, [e("div", { staticClass: "a-el" }, [e("span", [t._v(" " + t._s(o.title))])]), t.collapsed && o.notification ? e("span", { staticClass: "notification notification-toolbar" }, [t._v(t._s(o.notification))]) : t._e()])], 1);
  }) : [e("router-link", { attrs: { "active-class": "router-link-active", to: (p = t.toolBarItem) != null && p.to ? t.toolBarItem.to : "" } }, [e("span", [t._v(t._s((d = t.toolBarItem) == null ? void 0 : d.title))])])]], 2)], 2)])]);
}, y = [], b = /* @__PURE__ */ h(
  w,
  k,
  y
);
const S = b.exports, T = {};
var $ = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "default-container" }, [t._t("sidebar"), e("div", { staticClass: "main" }, [t._t("main")], 2)], 2);
}, L = [], x = /* @__PURE__ */ h(
  T,
  $,
  L
);
const B = x.exports;
export {
  B as DefaultLayout,
  S as SideBar
};
